import React from 'react';

import PropTypes from 'prop-types';
import { Dropdown, Icon } from 'semantic-ui-react';

import PartialActionsItem from './PartialActionsItem';

const PartialActions = ({ children }) => {
  return (
    <Dropdown icon={<Icon name="ellipsis horizontal" size="large" />} floating direction="left">
      <Dropdown.Menu>{children}</Dropdown.Menu>
    </Dropdown>
  );
};

PartialActions.propTypes = {
  children: PropTypes.node,
};

PartialActions.Item = PartialActionsItem;

PartialActions.defaultProps = {
  children: null,
};

export default PartialActions;
